module.exports = __webpack_public_path__ + "static/media/failure.f72d0d03.mp3";